module.exports = __webpack_public_path__ + "static/oil-5cf5d8ae1b689f0f2c8b760214b116f7.png";